
<template>
  <md-dialog :md-active.sync="isDialogVisible">
    <md-dialog-title>{{title}}</md-dialog-title>
    <md-dialog-content>
      <div class="sub-header">{{instructions}}</div>
    </md-dialog-content>

    <md-dialog-content>
      <EditField
        v-for="input in dialogInputs"
        :edit="!input.disabled"
        :input="input"
        v-show="!input.hidden"
        :key="input.label"
      />
    </md-dialog-content>

    <md-dialog-content>
      <slot/>
    </md-dialog-content>

    <md-dialog-actions>
      <md-button class @click="close">Cancel</md-button>
      <md-button class="md-primary" @click="submit">Ok</md-button>
    </md-dialog-actions>
  </md-dialog>
</template>

<script>
import EditField from "./editField.vue";

export default {
  name: "ModelDialog",
  components: { EditField },
  props: {
    show: Boolean,
    title: String,
    instructions: String,
    dialogInputs: Array
  },
  computed: {
    isDialogVisible: {
      get() {
        return this.show;
      },
      set(value) {
        if (!value) this.close();
      }
    }
  },
  methods: {
    close() {
      this.$emit("onClose");
    },
    submit() {
      this.$emit("onSubmit");
      this.close();
    }
  }
};
</script>


// WEBPACK FOOTER //
// modalDialog.vue?0b41de10